import { render, staticRenderFns } from "./SidebarCoupon.vue?vue&type=template&id=453ce1c2&scoped=true&"
import script from "./SidebarCoupon.vue?vue&type=script&lang=js&"
export * from "./SidebarCoupon.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCoupon.vue?vue&type=style&index=0&id=453ce1c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ce1c2",
  null
  
)

export default component.exports